import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isContactsTaxId(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CONTACTS_TAX_ID && typeof label === 'string' && typeof value === 'string';
}
function _formatContactsTaxId(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatContactsTaxId(submission) {
  if (isContactsTaxId(submission)) {
    return _formatContactsTaxId(submission);
  }
  return undefined;
}
//# sourceMappingURL=contacts-tax-id-preview.js.map